import { DecompressRgObjectDto } from "./index199.js";
import { dtoToRgObject } from "@project-rouge/rg-core";
function DecompressRgObject(obj) {
	if (!(obj instanceof Uint8Array)) return obj;
	return dtoToRgObject(DecompressRgObjectDto(obj));
}
export { DecompressRgObject };

//# sourceMappingURL=index200.js.map